module.exports = __webpack_public_path__ + "media/images/area/feature/chubu/related/vi/6-2e8b9fc4398aef0fd14a1533f47f75f9.jpg";